import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CashIncomeCreateDTO, CashIncomeState } from "../../../types/cash/cashIncome";

const initialFormState: CashIncomeCreateDTO = {

  sessionId: null,
  amount: 0,
  description: ""

};

const initialState: CashIncomeState = {

  form: initialFormState,
  loading: false,
  showModal: false

};

const cashIncomeSlice = createSlice({

  name: "cashIncome",

  initialState,

  reducers: {

    setCashIncomeForm(state, action: PayloadAction<CashIncomeCreateDTO>) {

      state.form = action.payload;

    },

    updateCashIncomeField(
      state,
      action: PayloadAction<{ field: keyof CashIncomeCreateDTO; value: any }>
    ) {

      const { field, value } = action.payload;

      state.form = {
        ...state.form,
        [field]: value
      };

    },

    clearCashIncomeForm(state) {

      state.form = initialFormState;

    },

    setLoading(state, action: PayloadAction<boolean>) {

      state.loading = action.payload;

    },

    openModal(state) {

      state.showModal = true;

    },

    closeModal(state) {

      state.showModal = false;

    }

  }

});

export const {

  setCashIncomeForm,
  updateCashIncomeField,
  clearCashIncomeForm,

  setLoading,

  openModal,
  closeModal

} = cashIncomeSlice.actions;

export default cashIncomeSlice.reducer;